<template>
    <div class='base_header'>
        <img class='icon' :src='icon'>
        <div class='bar'>
            <div class='bar_text' @click='intoView("title")'>产品中心</div>
            <div class='bar_text' @click='intoView("about")'>联系我们</div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'homePageHeader',
  data () {
    return {
      icon: require('../assets/img/logo_black.png')
    }
  },
  components: {
  },
  methods: {
    intoView (data) {
      document.getElementsByClassName(data)[0].scrollIntoView()
    }
  }
}
</script>

<style scoped>
    .base_header {
        width: 100%;
        height: 80px;
        position: relative;
    }
    .icon {
        width: 140px;
        height: 40px;
        margin-left: 15%;
        position: relative;
        top: 50%;
        transform: translate(-50%, -50%);
    }
    .bar {
        height: 50px;
        display: inline-flex;
        vertical-align: middle;
        position: absolute;
        top: 1.8em;
        right: 5em;
    }
    .bar_text {
        margin-left: 5em;
        cursor: pointer;
        display: inline;
    }
</style>



// WEBPACK FOOTER //
// src/components/header.vue